module.exports = __webpack_public_path__ + "static/media/play-store.675ae3a2.png";